// League tier definitions for styling and sorting

// Legacy hardcoded list - now deprecated in favor of database-driven active leagues
// Kept for fallback purposes only
export const SUPPORTED_LEAGUES = [
  'ENG_PL', 'ENG_CH', 'ENG_L1',
  'GER_BL', 'GER_B2',
  'ITA_SA', 'ITA_SB',
  'ESP_LL', 'ESP_SL',
  'FRA_L1', 'FRA_L2',
  'DEN_SL',
  'SCO_PL',
  'NED_ED',
  'POR_LP',
  'BEL_PL',
  'AUT_BL',
];

// DEPRECATED: Use isLeagueSupportedDynamic from useActiveLeagues hook instead
export const isLeagueSupported = (leagueCode: string): boolean => {
  return SUPPORTED_LEAGUES.includes(leagueCode);
};

export const LEAGUE_TIERS: Record<string, { tier: number; label: string; color: string }> = {
  // England
  ENG_PL: { tier: 1, label: "PL", color: "bg-purple-500" },
  ENG_CH: { tier: 2, label: "CH", color: "bg-amber-500" },
  ENG_L1: { tier: 3, label: "L1", color: "bg-amber-400" },
  ENG_L2: { tier: 4, label: "L2", color: "bg-amber-300" },
  ENG_NL: { tier: 5, label: "NL", color: "bg-gray-400" },
  // Germany
  GER_BL: { tier: 1, label: "BL", color: "bg-red-500" },
  GER_BL2: { tier: 2, label: "BL2", color: "bg-red-400" },
  GER_B2: { tier: 2, label: "2.BL", color: "bg-red-400" },
  // Spain
  ESP_LL: { tier: 1, label: "LL", color: "bg-orange-500" },
  ESP_SL: { tier: 2, label: "SL", color: "bg-orange-400" },
  // Italy
  ITA_SA: { tier: 1, label: "SA", color: "bg-blue-500" },
  ITA_SB: { tier: 2, label: "SB", color: "bg-blue-400" },
  // France
  FRA_L1: { tier: 1, label: "L1", color: "bg-blue-600" },
  FRA_L2: { tier: 2, label: "L2", color: "bg-blue-400" },
  // Netherlands
  NED_ED: { tier: 1, label: "ED", color: "bg-orange-500" },
  // Portugal
  POR_LP: { tier: 1, label: "LP", color: "bg-green-600" },
  // Belgium
  BEL_PL: { tier: 1, label: "JPL", color: "bg-yellow-500" },
  // Austria
  AUT_BL: { tier: 1, label: "BL", color: "bg-red-400" },
  // Denmark
  DEN_SL: { tier: 1, label: "SL", color: "bg-red-500" },
  // Scotland
  SCO_PL: { tier: 1, label: "SPL", color: "bg-blue-700" },
  // Women's leagues
  ENG_WSL: { tier: 1, label: "WSL", color: "bg-fuchsia-600" },
  FRA_D1F: { tier: 1, label: "PLF", color: "bg-fuchsia-500" },
  GER_FBL: { tier: 1, label: "FBL", color: "bg-fuchsia-700" },
};

export const getLeagueTierInfo = (leagueCode: string) => {
  return LEAGUE_TIERS[leagueCode] || { tier: 1, label: leagueCode, color: "bg-gray-500" };
};

export const getLeagueBadgeColor = (leagueCode: string): string => {
  const info = getLeagueTierInfo(leagueCode);
  if (info.tier === 1) {
    return "bg-primary/20 text-primary border-primary/30";
  }
  return "bg-amber-500/20 text-amber-700 dark:text-amber-400 border-amber-500/30";
};
